import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSize } from 'ahooks';
import { Tooltip } from 'antd';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { TextArea } from 'components/facade/textarea';
import { SingleLineEllipsis } from 'components/styles';
import { HeightStyle } from './input';
const Wrapper = styled.div`
  position: relative;
  height: ${HeightStyle};
  max-width: 100%;
  overflow: hidden;

  span {
    position: absolute;
    visibility: hidden;
    display: inline-block;
    padding: calc(var(--spacing-04) - 1.5px) var(--spacing-05);
    max-width: ${({ contentMaxWidth })=>contentMaxWidth !== null && contentMaxWidth !== void 0 ? contentMaxWidth : '100%'};
    height: ${HeightStyle};
    ${SingleLineEllipsis};
  }

  textarea {
    padding: calc(var(--spacing-04) - 1.5px) var(--spacing-05);
    max-height: ${HeightStyle} !important;
    ${SingleLineEllipsis};
    transition: all 0.3s, height 0s, width 0s, max-width 0s, min-width 0s,
      top 0s;
  }

  &:focus-within {
    textarea {
      max-height: unset !important;
      overflow: auto;
      white-space: normal;
      width: ${({ contentWidth })=>`${contentWidth}px`};
      min-width: ${({ wrapperWidth })=>`${wrapperWidth}px`};
      max-width: ${({ contentMaxWidth, wrapperWidth })=>contentMaxWidth !== null && contentMaxWidth !== void 0 ? contentMaxWidth : `${wrapperWidth}px`};
      position: fixed;
      top: ${({ wrapperTop })=>`${wrapperTop}px`};
      z-index: var(--zindex-layer-00);
    }
  }
`;
const getLongestLine = (value)=>value.split('\n').reduce((longLine, currentLine)=>currentLine.length > longLine.length ? currentLine : longLine, '');
export const ExpandableInput = ({ value, autoSize, placeholder, onFocus, onBlur, contentMaxWidth, ...rest })=>{
    var _ref, _ref1, _ref2;
    const wrapperRef = useRef(null);
    const wrapperWidth = useSize(wrapperRef);
    const [wrapperTop, setWrapperTop] = useState(0);
    const contentRef = useRef(null);
    const contentWidth = useSize(contentRef);
    const [focussed, setFocussed] = useState(false);
    const showPlaceholder = value == null || value.toString().trim().length === 0;
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: rest.disabled ? value : '',
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            ref: wrapperRef,
            wrapperWidth: (_ref = wrapperWidth === null || wrapperWidth === void 0 ? void 0 : wrapperWidth.width) !== null && _ref !== void 0 ? _ref : 0,
            wrapperTop: wrapperTop,
            contentWidth: (_ref1 = contentWidth === null || contentWidth === void 0 ? void 0 : contentWidth.width) !== null && _ref1 !== void 0 ? _ref1 : 0 + 32,
            contentMaxWidth: contentMaxWidth,
            children: [
                /*#__PURE__*/ _jsx("span", {
                    ref: contentRef,
                    children: showPlaceholder ? placeholder : getLongestLine((_ref2 = value === null || value === void 0 ? void 0 : value.toString()) !== null && _ref2 !== void 0 ? _ref2 : '')
                }),
                /*#__PURE__*/ _jsx(TextArea, {
                    ...rest,
                    value: focussed ? value : value === null || value === void 0 ? void 0 : value.toString().replace(/\n/g, ' '),
                    onFocus: (e)=>{
                        var _ref;
                        var _wrapperRef_current;
                        setWrapperTop((_ref = (_wrapperRef_current = wrapperRef.current) === null || _wrapperRef_current === void 0 ? void 0 : _wrapperRef_current.getBoundingClientRect().top) !== null && _ref !== void 0 ? _ref : 0);
                        setFocussed(true);
                        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
                    },
                    onBlur: (e)=>{
                        setFocussed(false);
                        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
                    },
                    autoSize: autoSize !== null && autoSize !== void 0 ? autoSize : {
                        maxRows: 6
                    },
                    placeholder: placeholder
                })
            ]
        })
    });
};
